import script from "./ChatBotGemini.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatBotGemini.vue?vue&type=script&setup=true&lang=js"

import "./ChatBotGemini.vue?vue&type=style&index=0&id=a5d80898&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a5d80898"]])

export default __exports__